import { z } from 'zod';
import { CertificationKindWithAll } from './-constants';
export const CertificationTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // タブフィルタ
  certificationKind: z.nativeEnum(CertificationKindWithAll).default(CertificationKindWithAll.ALL),
  // フィルタ
  freeText: z.string().optional()
});